export function mapRegistrationApiErrors(error: Error): string {
  let message = "";

  switch (error.name) {
    case "InvalidPasswordException":
      message = "Invalid password format. Please ensure your password meets all requirements.";
      break;

    case "UsernameExistsException":
      message = "An account with this email already exists. Please sign in instead, or use a different email address.";
      break;

    case "CodeMismatchException":
      message = "Invalid verification code. Please check your email and try again.";
      break;

    case "InvalidParameterException":
      message = "Invalid registration data. Please check all fields and try again.";
      break;

    case "UserLambdaValidationException":
      message = "Validation error. Please ensure all information is correct.";
      break;

    default:
      message = error.message || "An error occurred during registration. Please try again.";
      break;
  }

  return message;
}
